export const sequence_detail_logs_en = {
  sequence_detail_logs_count: "0 logs | 1 log | {count} logs",
  sequence_detail_logs: "logs",
  sequence_detail_logs_column_timestamp: "Timestamp",
  sequence_detail_logs_column_name: "Channel node name",
  sequence_detail_logs_column_action_type: "Step actions",
  sequence_detail_logs_column_step: "Sequence step",
  sequence_detail_logs_column_target: "Target",
  sequence_detail_logs_column_node_type: "Channel node type",
  sequence_detail_logs_column_error: "Error",
  sequnece_logs_target_deleted: "Target deleted",

  timestamp_descending: "Timestamp (Newest First)",
  timestamp_ascending: "Timestamp (Oldest First)",
  sequence_targets_filter_targets: "Targets",
  sequence_targets_filter_sequence_steps: "Sequence steps",
  sequence_targets_filter_channel_nodes_type: "Channel nodes",
  sequence_targets_filter_channel_types: "Channel types",
  sequence_targets_filter_channel_nodes: "Channel node types",
};

export const sequence_detail_logs_zh = {
  sequence_detail_logs_count: "0 条日志 | 1 条日志 | {count} 条日志",
  sequence_detail_logs: "日志",
  sequence_detail_logs_column_timestamp: "时间戳",
  sequence_detail_logs_column_name: "渠道节点名称",
  sequence_detail_logs_column_action_type: "操作类型",
  sequence_detail_logs_column_step: "流程步骤",
  sequence_detail_logs_column_target: "目标",
  sequence_detail_logs_column_node_type: "渠道节点类型",
  sequence_detail_logs_column_error: "错误信息",
  sequnece_logs_target_deleted: "目标已删除",

  timestamp_descending: "时间戳（最新优先）",
  timestamp_ascending: "时间戳（最旧优先）",
  sequence_targets_filter_targets: "目标",
  sequence_targets_filter_sequence_steps: "序列步骤",
  sequence_targets_filter_channel_nodes_type: "渠道节点",
  sequence_targets_filter_channel_types: "渠道类型",
  sequence_targets_filter_channel_nodes: "渠道节点类型",
};

export const sequence_detail_logs_zh_tw = {
  sequence_detail_logs_count: "0 筆日誌 | 1 筆日誌 | {count} 筆日誌",
  sequence_detail_logs: "日誌",
  sequence_detail_logs_column_timestamp: "時間戳記",
  sequence_detail_logs_column_name: "通道節點名稱",
  sequence_detail_logs_column_action_type: "操作類型",
  sequence_detail_logs_column_step: "流程步驟",
  sequence_detail_logs_column_target: "目標",
  sequence_detail_logs_column_node_type: "通道節點類型",
  sequence_detail_logs_column_error: "錯誤資訊",
  sequnece_logs_target_deleted: "目標已刪除",

  timestamp_descending: "時間戳記（最新優先）",
  timestamp_ascending: "時間戳記（最舊優先）",
  sequence_targets_filter_targets: "目標",
  sequence_targets_filter_sequence_steps: "序列步驟",
  sequence_targets_filter_channel_nodes_type: "渠道節點",
  sequence_targets_filter_channel_types: "渠道類型",
  sequence_targets_filter_channel_nodes: "渠道節點類型",
};

export const sequence_detail_logs_japanese = {
  sequence_detail_logs_count: "0 件のログ | 1 件のログ | {count} 件のログ",
  sequence_detail_logs: "ログ",
  sequence_detail_logs_column_timestamp: "タイムスタンプ",
  sequence_detail_logs_column_name: "チャネルノード名",
  sequence_detail_logs_column_action_type: "操作タイプ",
  sequence_detail_logs_column_step: "プロセスステップ",
  sequence_detail_logs_column_target: "ターゲット",
  sequence_detail_logs_column_node_type: "チャネルノードタイプ",
  sequence_detail_logs_column_error: "エラー情報",
  sequnece_logs_target_deleted: "ターゲットは削除されました",

  timestamp_descending: "タイムスタンプ（新しい順）",
  timestamp_ascending: "タイムスタンプ（古い順）",
  sequence_targets_filter_targets: "ターゲット",
  sequence_targets_filter_sequence_steps: "シーケンスステップ",
  sequence_targets_filter_channel_nodes_type: "チャネルノード",
  sequence_targets_filter_channel_types: "チャネルタイプ",
  sequence_targets_filter_channel_nodes: "チャネルノードタイプ"
};

export const sequence_detail_logs_korean = {
  sequence_detail_logs_count: "0개 로그 | 1개 로그 | {count}개 로그",
  sequence_detail_logs: "로그",
  sequence_detail_logs_column_timestamp: "타임스탬프",
  sequence_detail_logs_column_name: "채널 노드명",
  sequence_detail_logs_column_action_type: "작업 유형",
  sequence_detail_logs_column_step: "프로세스 단계",
  sequence_detail_logs_column_target: "대상",
  sequence_detail_logs_column_node_type: "채널 노드 유형",
  sequence_detail_logs_column_error: "오류 정보",
  sequnece_logs_target_deleted: "대상이 삭제됨",

  timestamp_descending: "타임스탬프(최신순)",
  timestamp_ascending: "타임스탬프(오래된순)",
  sequence_targets_filter_targets: "대상",
  sequence_targets_filter_sequence_steps: "시퀀스 단계",
  sequence_targets_filter_channel_nodes_type: "채널 노드",
  sequence_targets_filter_channel_types: "채널 유형",
  sequence_targets_filter_channel_nodes: "채널 노드 유형"
};

export const sequence_detail_logs_hindi = {
  sequence_detail_logs_count: "0 लॉग | 1 लॉग | {count} लॉग",
  sequence_detail_logs: "लॉग",
  sequence_detail_logs_column_timestamp: "टाइमस्टैम्प",
  sequence_detail_logs_column_name: "चैनल नोड नाम",
  sequence_detail_logs_column_action_type: "ऑपरेशन प्रकार",
  sequence_detail_logs_column_step: "प्रक्रिया चरण",
  sequence_detail_logs_column_target: "लक्ष्य",
  sequence_detail_logs_column_node_type: "चैनल नोड प्रकार",
  sequence_detail_logs_column_error: "त्रुटि जानकारी",
  sequnece_logs_target_deleted: "लक्ष्य हटा दिया गया",

  timestamp_descending: "टाइमस्टैम्प (नवीनतम पहले)",
  timestamp_ascending: "टाइमस्टैम्प (पुराने पहले)",
  sequence_targets_filter_targets: "लक्ष्य",
  sequence_targets_filter_sequence_steps: "अनुक्रम चरण",
  sequence_targets_filter_channel_nodes_type: "चैनल नोड",
  sequence_targets_filter_channel_types: "चैनल प्रकार",
  sequence_targets_filter_channel_nodes: "चैनल नोड प्रकार"
};